import { v4 } from 'uuid'
import { sendCommand } from 'react-wot-bootstrap'
const WoTClientMessageCallbacks = {}
const SEND_LOGS = 'send_logs'

export const createPartnerID = () => v4()


export const sendLogs = (feature, group, action, logLevel, params) => new Promise((resolve, reject) => {
    const commandData = {
        command: 'ui_logging',
        params: {
            action: 'log',
            feature: feature,
            group: group,
            log_action: action,
            log_level: logLevel,
            params: params,
        },
        web_id: SEND_LOGS,
    }

    WoTClientMessageCallbacks[commandData.web_id] = (data) => {
        if (Object.keys(data).length) {
            resolve(data)
        } else {
            reject()
        }
    }
    sendCommand(commandData)
})



// WEBPACK FOOTER //
// ./helpers/uilogging/helpers.js